/* Boivin Leather - cart drawer refill offer (replaces Section Store "You may also like")
   Shows once per session when the cart has a journal, no refills, and the shopper
   hasn't already seen the add-to-cart refill pop-up. Offers the refill 2-pack either
   one-time (50% off via the "Welcome Bundle" automatic discount) or on one of the Seal
   "Journal starter" plans: Monthly Refills (50% off first delivery, then 20% off) or
   Quarterly Refills (50% off first delivery, then 10% off). */
/* Cart logic:
   - Journal in cart, no refills, refill pop-up not shown  -> full offer (Monthly / Quarterly / one-time; Monthly preselected)
   - Journal in cart + one one-time refill pack, Subscribe & Save not offered yet -> "make it a subscription" (swaps the line)
   - Journal in cart + regular Monthly/Quarterly refill subscription -> auto-switched to the Journal starter plan
   - Anything else (incl. said no to refills)               -> Section Store's own "You may also like" stays visible */
/* Pricing display: every discounted price shows the original (regular one-time) price crossed out first. */
(function () {
  if (window.__blrRefillOffer) return;
  window.__blrRefillOffer = true;

  var REFILL_HANDLE = 'boivin-paper-a6';
  var STARTER = /journal starter/i;
  var FLAG = 'blr_refill_offered'; // set by the add-to-cart pop-up when it shows the refill offer
  var DISMISS = 'blr_refill_card_dismissed';
  var SUBFLAG = 'blr_sub_offered'; // set by the refills-page Subscribe & Save pop-up

  function ss(k, v) {
    try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) { return null; }
  }
  function money(c) { var d = c / 100; return '$' + (d % 1 === 0 ? d : d.toFixed(2)); }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  /* original price crossed out, then the sale price (just the price when there's no discount) */
  function was(orig, now) { return (orig > now ? '<s>' + money(orig) + '</s> ' : '') + money(now); }

  /* ---------- 1. keep the "Journal starter" plan out of the product-page Seal widget ---------- */
  function scrubSeal() {
    var opts = document.querySelectorAll('select.sls-select option');
    for (var i = 0; i < opts.length; i++) {
      var o = opts[i];
      if (STARTER.test(o.textContent)) {
        var sel = o.parentElement;
        var wasSelected = o.selected;
        o.remove();
        if (wasSelected && sel) { sel.selectedIndex = 0; sel.dispatchEvent(new Event('change', { bubbles: true })); }
      }
    }
  }

  /* ---------- 2. cart drawer offer ---------- */
  var product = null;
  function getProduct() {
    if (product) return Promise.resolve(product);
    return fetch('/products/' + REFILL_HANDLE + '.js').then(function (r) { return r.json(); }).then(function (p) { product = p; return p; });
  }
  function getCart() { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function root() { var h = document.querySelector('section-store--cart-block'); return h && h.shadowRoot; }

  var CSS = '' +
  '.cart-title{letter-spacing:-0.05em!important}' +
    '.blr-offer{margin:14px 0 6px;padding:14px;border:1px solid #CEC8BB;background:#FCFAF4;color:#3f3a30;font-size:13px;line-height:1.35}' +
    '.blr-offer__top{display:flex;gap:12px;align-items:center;margin-bottom:10px}' +
    '.blr-offer__img{width:56px;height:56px;flex:0 0 56px;object-fit:cover;background:#eee}' +
    '.blr-offer__eyebrow{font-size:11px;letter-spacing:.08em;text-transform:uppercase;opacity:.7;margin:0 0 2px}' +
    '.blr-offer__title{font-size:15px;font-weight:700;margin:0}' +
    '.blr-offer__x{margin-left:auto;align-self:flex-start;background:none;border:0;font-size:18px;line-height:1;cursor:pointer;color:inherit;opacity:.6;padding:0 2px}' +
    '.blr-offer__chips{display:flex;gap:6px;flex-wrap:wrap;margin:0 0 10px}' +
    '.blr-offer__chip{border:1px solid #b9b2a3;background:#fff;color:inherit;padding:5px 11px;font-size:12px;cursor:pointer;border-radius:20px;font-family:inherit}' +
    '.blr-offer__chip[aria-pressed="true"]{background:#3f3a30;border-color:#3f3a30;color:#fff}' +
    '.blr-offer__opt{display:flex;gap:10px;align-items:flex-start;width:100%;text-align:left;border:1px solid #CEC8BB;background:#fff;color:inherit;padding:9px 10px;margin:0 0 6px;cursor:pointer;font-family:inherit;font-size:13px}' +
    '.blr-offer__opt[aria-pressed="true"]{border:2px solid #3f3a30;padding:8px 9px}' +
    '.blr-offer__dot{width:14px;height:14px;flex:0 0 14px;margin-top:2px;border:1.5px solid #3f3a30;border-radius:50%;position:relative}' +
    '.blr-offer__opt[aria-pressed="true"] .blr-offer__dot:after{content:"";position:absolute;inset:2px;border-radius:50%;background:#3f3a30}' +
    '.blr-offer__main{flex:1}' +
    '.blr-offer__name{font-weight:600;display:block}' +
    '.blr-offer__save{display:inline-block;margin-left:6px;padding:2px 8px;border-radius:20px;background:#d8f0df;border:1px solid #9fd3ad;color:#14592f;font-size:11px;font-weight:700;letter-spacing:.02em;vertical-align:1px}' +
    '.blr-offer__sub{display:block;font-size:11.5px;opacity:.75;margin-top:2px}' +
    '.blr-offer s{opacity:.6}' +
    '.blr-offer__price{white-space:nowrap;text-align:right;font-weight:600}' +
    '.blr-offer__price s{font-weight:400;opacity:.55;margin-right:4px}' +
    '.blr-offer__add{width:100%;margin-top:4px;padding:11px;border:0;background:#444444;color:#FCFAF4;font-size:14px;font-weight:600;cursor:pointer;font-family:inherit}' +
    '.blr-offer__add[disabled]{opacity:.6;cursor:wait}' +
    '.blr-offer__err{color:#991B1B;font-size:12px;margin:6px 0 0}';

  function ensureStyle(sr) {
    if (sr.querySelector('style[data-blr-offer]')) return;
    var st = document.createElement('style');
    st.setAttribute('data-blr-offer', '');
    st.textContent = CSS;
    sr.appendChild(st);
    var hide = document.createElement('style');
    hide.setAttribute('data-blr-hide-upsell', '');
    hide.textContent = '.cart-products-upsell{display:none!important}';
    hide.disabled = true;
    sr.appendChild(hide);
  }
  function hideAppUpsell(sr, on) {
    var h = sr.querySelector('style[data-blr-hide-upsell]');
    if (h) h.disabled = !on;
  }
  function starterPlans(p) {
    var plans = [];
    (p.selling_plan_groups || []).forEach(function (g) {
      g.selling_plans.forEach(function (s) {
        if (!STARTER.test(s.name)) return;
        var quarterly = /quarter|3 month/i.test(s.name + ' ' + (s.options || []).map(function (o) { return o.value; }).join(' '));
        var adj = s.price_adjustments || [];
        var save = adj[1] && adj[1].value_type === 'percentage' ? adj[1].value : (quarterly ? 10 : 20);
        plans.push({ plan: s, mode: quarterly ? 'quarterly' : 'monthly', label: quarterly ? 'Quarterly Refills' : 'Monthly Refills', per: quarterly ? ' every 3 months' : '/mo', save: save });
      });
    });
    plans.sort(function (a, b) { return a.mode === 'monthly' ? -1 : 1; });
    return plans;
  }
  function saveBadge(pl) { return pl.save ? ' <span class="blr-offer__save">Save ' + pl.save + '%</span>' : ''; }
  function allocFor(v, plan) {
    return (v.selling_plan_allocations || []).filter(function (a) { return a.selling_plan_id === plan.id; })[0] || null;
  }

  /* "Make it a subscription" card: swaps a one-time refill line to a Journal starter plan */
  function buildConvert(p, line) {
    var v = p.variants.filter(function (x) { return x.id === line.variant_id; })[0];
    if (!v) return null;
    var subs = starterPlans(p).map(function (pl) {
      var a = allocFor(v, pl.plan);
      if (!a) return null;
      return { pl: pl, first: a.price, after: a.price_adjustments && a.price_adjustments[1] ? a.price_adjustments[1].price : null };
    }).filter(Boolean);
    if (!subs.length) return null;
    var state = { mode: subs[0].pl.mode };
    var el = document.createElement('div');
    el.className = 'blr-offer';
    el.setAttribute('data-key', 'convert:' + line.key);

    function draw() {
      el.innerHTML =
        '<div class="blr-offer__top">' +
          (p.featured_image ? '<img class="blr-offer__img" src="' + esc(p.featured_image) + '&width=120" alt="">' : '') +
          '<div><p class="blr-offer__eyebrow">Never run out of paper</p><p class="blr-offer__title">Subscribe &amp; Save</p></div>' +
          '<button type="button" class="blr-offer__x" aria-label="No thanks" data-x>&times;</button>' +
        '</div>' +
        '<p style="margin:0 0 10px">Same ' + was(v.price, subs[0].first) + ' today for your ' + esc(v.title) + '. Skip, pause or cancel anytime.</p>' +
        subs.map(function (x) {
          return '<button type="button" class="blr-offer__opt" data-mode="' + x.pl.mode + '" aria-pressed="' + (state.mode === x.pl.mode) + '">' +
            '<span class="blr-offer__dot"></span><span class="blr-offer__main"><span class="blr-offer__name">' + x.pl.label + saveBadge(x.pl) + '</span>' +
            '<span class="blr-offer__sub">' + was(v.price, x.first) + ' today' + (x.after ? ', then ' + was(v.price, x.after) + x.pl.per : '') + '</span></span>' +
            '<span class="blr-offer__price">' + was(v.price, x.first) + '</span>' +
          '</button>';
        }).join('') +
        '<button type="button" class="blr-offer__add" data-add>Switch to subscription</button>' +
        '<p class="blr-offer__err" hidden></p>';
      el.querySelectorAll('.blr-offer__opt').forEach(function (b) {
        b.addEventListener('click', function () { state.mode = b.getAttribute('data-mode'); draw(); });
      });
      el.querySelector('[data-x]').addEventListener('click', function () { ss(DISMISS, '1'); el.remove(); var sr = root(); if (sr) hideAppUpsell(sr, false); });
      el.querySelector('[data-add]').addEventListener('click', function (e) {
        var btn = e.currentTarget;
        btn.disabled = true; btn.textContent = 'Switching...';
        var chosen = subs.filter(function (x) { return x.pl.mode === state.mode; })[0];
        ss(DISMISS, '1');
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: line.key, quantity: line.quantity, selling_plan: chosen.pl.plan.id })
        }).then(function (r) { return r.json(); }).then(function (res) {
          if (res && res.status) throw new Error(res.description || res.message || 'Could not switch');
          refreshDrawer();
        }).catch(function (err) {
          btn.disabled = false; btn.textContent = 'Switch to subscription';
          var m = el.querySelector('.blr-offer__err'); m.hidden = false; m.textContent = String(err.message || err);
        });
      });
    }
    draw();
    return el;
  }

  function journalSize(item) {
    var ov = item.options_with_values || [];
    for (var i = 0; i < ov.length; i++) if (/size/i.test(ov[i].name)) return ov[i].value;
    return (item.variant_options && item.variant_options[0]) || null;
  }

  function buildCard(p, size) {
    var plans = starterPlans(p);
    var choices = p.variants.filter(function (v) { return v.available && v.option1 === size && /2 pack/i.test(v.option2 || ''); });
    if (!choices.length) return null;

    var state = { variant: choices[0], mode: 'monthly' }; // Monthly preselected (falls back to one-time if unavailable)
    var el = document.createElement('div');
    el.className = 'blr-offer';
    el.setAttribute('data-key', 'offer:' + size);

    function alloc(v, plan) {
      if (!plan) return null;
      return (v.selling_plan_allocations || []).filter(function (a) { return a.selling_plan_id === plan.id; })[0] || null;
    }

    function draw() {
      var v = state.variant;
      var once = Math.round(v.price / 2);
      var subs = plans.map(function (pl) {
        var a = alloc(v, pl.plan);
        if (!a) return null;
        var after = a.price_adjustments && a.price_adjustments[1] ? a.price_adjustments[1].price : null;
        return { pl: pl, first: a.price, after: after };
      }).filter(Boolean);
      if (state.mode !== 'once' && !subs.some(function (x) { return x.pl.mode === state.mode; })) state.mode = 'once';

      var chips = choices.map(function (c, i) {
        return '<button type="button" class="blr-offer__chip" data-i="' + i + '" aria-pressed="' + (c.id === v.id) + '">' + esc(c.option3 || c.title) + '</button>';
      }).join('');

      el.innerHTML =
        '<div class="blr-offer__top">' +
          (p.featured_image ? '<img class="blr-offer__img" src="' + esc(p.featured_image) + '&width=120" alt="">' : '') +
          '<div><p class="blr-offer__eyebrow">Complete your journal</p><p class="blr-offer__title">Notebook Refills, 50% off</p></div>' +
          '<button type="button" class="blr-offer__x" aria-label="No thanks" data-x>&times;</button>' +
        '</div>' +
        '<div class="blr-offer__chips">' + chips + '</div>' +
        subs.map(function (x) {
          return '<button type="button" class="blr-offer__opt" data-mode="' + x.pl.mode + '" aria-pressed="' + (state.mode === x.pl.mode) + '">' +
            '<span class="blr-offer__dot"></span><span class="blr-offer__main"><span class="blr-offer__name">' + x.pl.label + saveBadge(x.pl) + '</span>' +
            '<span class="blr-offer__sub">' + was(v.price, x.first) + ' today' + (x.after ? ', then ' + was(v.price, x.after) + x.pl.per : '') + '. Skip, pause or cancel anytime.</span></span>' +
            '<span class="blr-offer__price">' + was(v.price, x.first) + '</span>' +
          '</button>';
        }).join('') +
        '<button type="button" class="blr-offer__opt" data-mode="once" aria-pressed="' + (state.mode === 'once') + '">' +
          '<span class="blr-offer__dot"></span><span class="blr-offer__main"><span class="blr-offer__name">One-time ' + esc(size) + ' 2-pack</span></span>' +
          '<span class="blr-offer__price">' + was(v.price, once) + '</span>' +
        '</button>' +
        '<button type="button" class="blr-offer__add" data-add>Add to order</button>' +
        '<p class="blr-offer__err" hidden></p>';

      el.querySelectorAll('.blr-offer__chip').forEach(function (b) {
        b.addEventListener('click', function () { state.variant = choices[Number(b.getAttribute('data-i'))]; draw(); });
      });
      el.querySelectorAll('.blr-offer__opt').forEach(function (b) {
        b.addEventListener('click', function () { state.mode = b.getAttribute('data-mode'); draw(); });
      });
      el.querySelector('[data-x]').addEventListener('click', function () { ss(DISMISS, '1'); el.remove(); var sr = root(); if (sr) hideAppUpsell(sr, false); });
      el.querySelector('[data-add]').addEventListener('click', function (e) {
        var btn = e.currentTarget;
        btn.disabled = true; btn.textContent = 'Adding...';
        var item = { id: state.variant.id, quantity: 1 };
        var chosen = plans.filter(function (pl) { return pl.mode === state.mode; })[0];
        if (chosen) item.selling_plan = chosen.plan.id;
        ss(DISMISS, '1');
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [item] })
        }).then(function (r) { return r.json(); }).then(function (res) {
          if (res && res.status) throw new Error(res.description || res.message || 'Could not add');
          refreshDrawer();
        }).catch(function (err) {
          btn.disabled = false; btn.textContent = 'Add to order';
          var m = el.querySelector('.blr-offer__err'); m.hidden = false; m.textContent = String(err.message || err);
        });
      });
    }
    draw();
    return el;
  }

  /* ---------- 3. journal + refill subscription => Journal starter plan (50% off first delivery) ----------
     The "Welcome Bundle" automatic discount only covers one-time refills. When a journal is in the cart,
     a regular Monthly/Quarterly refill line (qty 1) is switched to the matching "Journal starter" plan;
     if the journal is removed, a starter line is switched back to the regular plan. */
  var tried = {};
  function planInfo(p) {
    var map = {};
    (p.selling_plan_groups || []).forEach(function (g) {
      g.selling_plans.forEach(function (s) {
        map[s.id] = { id: s.id, starter: STARTER.test(s.name), mode: /quarter/i.test(s.name) ? 'quarterly' : 'monthly' };
      });
    });
    return map;
  }
  function syncPlans(cart, p, journal, refills) {
    var map = planInfo(p), all = Object.keys(map).map(function (k) { return map[k]; });
    var find = function (mode, starter) { return all.filter(function (x) { return x.mode === mode && x.starter === starter; })[0]; };
    var subLines = refills.filter(function (i) { return i.selling_plan_allocation && map[i.selling_plan_allocation.selling_plan.id]; });
    var target = null, line = null;
    if (journal) {
      var hasStarter = subLines.some(function (i) { return map[i.selling_plan_allocation.selling_plan.id].starter; });
      if (!hasStarter) {
        line = subLines.filter(function (i) { return i.quantity === 1 && !map[i.selling_plan_allocation.selling_plan.id].starter; })[0];
        if (line) target = find(map[line.selling_plan_allocation.selling_plan.id].mode, true);
      }
    } else {
      line = subLines.filter(function (i) { return map[i.selling_plan_allocation.selling_plan.id].starter; })[0];
      if (line) target = find(map[line.selling_plan_allocation.selling_plan.id].mode, false);
    }
    if (!line || !target) return Promise.resolve(false);
    var k = line.key + '>' + target.id;
    if (tried[k]) return Promise.resolve(false);
    tried[k] = true;
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: line.key, quantity: line.quantity, selling_plan: target.id })
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (res && res.status) return false;
      refreshDrawer();
      return true;
    }).catch(function () { return false; });
  }
  function cartItems(cart, p) {
    var journal = null, refills = [];
    cart.items.forEach(function (i) {
      if (i.product_type === 'Journal' && !journal) journal = i;
      if (i.handle === REFILL_HANDLE || i.product_id === p.id) refills.push(i);
    });
    return { journal: journal, refills: refills };
  }
  function syncNow() {
    Promise.all([getCart(), getProduct()]).then(function (res) {
      var c = cartItems(res[0], res[1]);
      return syncPlans(res[0], res[1], c.journal, c.refills);
    }).catch(function () {});
  }

  function refreshDrawer() {
    // Ask Section Store's cart to re-read the cart; fall back to Shopify's standard events.
    try { document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); } catch (e) {}
    try { window.dispatchEvent(new Event('cart:updated')); } catch (e) {}
    try {
      var h = document.querySelector('section-store--cart-block');
      if (h && typeof h.refresh === 'function') h.refresh();
    } catch (e) {}
    setTimeout(update, 600);
  }

  var busy = false, again = false;
  function update() {
    if (busy) { again = true; return; }
    var sr = root();
    if (!sr) return;
    var body = sr.querySelector('.cart-body');
    if (!body) return;
    ensureStyle(sr);
    busy = true;
    Promise.all([getCart(), getProduct()]).then(function (res) {
      var cart = res[0], p = res[1];
      var c = cartItems(cart, p), journal = c.journal, refills = c.refills;
      return syncPlans(cart, p, journal, refills).then(function (changed) {
      if (changed) return; // drawer refresh re-runs update with the new cart
      var mode = null, key = null;
      if (journal && !ss(DISMISS)) {
        if (!refills.length && !ss(FLAG)) { mode = 'offer'; key = 'offer:' + journalSize(journal); }
        else if (refills.length === 1 && !refills[0].selling_plan_allocation && refills[0].quantity === 1 && !ss(SUBFLAG)) { mode = 'convert'; key = 'convert:' + refills[0].key; }
      }
      var existing = sr.querySelector('.blr-offer');
      hideAppUpsell(sr, !!mode);
      if (!mode) { if (existing) existing.remove(); return; }
      if (existing && existing.getAttribute('data-key') === key && body.contains(existing)) return;
      if (existing) existing.remove();
      var card = mode === 'offer' ? buildCard(p, journalSize(journal)) : buildConvert(p, refills[0]);
      if (!card) { hideAppUpsell(sr, false); return; }
      var anchor = body.querySelector('.cart-products-upsell');
      if (anchor) anchor.parentNode.insertBefore(card, anchor); else body.appendChild(card);
      });
    }).catch(function () {}).then(function () {
      busy = false;
      if (again) { again = false; update(); }
    });
  }

  /* ---------- wiring ---------- */
  var pending = null;
  function schedule() {
    if (pending) return;
    pending = setTimeout(function () { pending = null; update(); }, 250);
  }
  var observedRoot = null;
  function watchRoot() {
    var sr = root();
    if (sr && sr !== observedRoot) {
      observedRoot = sr;
      new MutationObserver(function (muts) {
        // ignore mutations caused only by our own card
        for (var i = 0; i < muts.length; i++) {
          var t = muts[i].target;
          if (!(t.closest && t.closest('.blr-offer')) && !(t.classList && t.classList.contains('blr-offer'))) { schedule(); return; }
        }
      }).observe(sr, { childList: true, subtree: true });
      schedule();
    }
  }
  var tick = 0;
  new MutationObserver(function () {
    if (tick) return;
    tick = setTimeout(function () { tick = 0; watchRoot(); scrubSeal(); }, 50);
  }).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('DOMContentLoaded', function () { scrubSeal(); watchRoot(); syncNow(); });
  // also re-check after any cart add/change made by the theme or apps
  (function () {
    var of = window.fetch;
    if (!of || of.__blrWrapped) return;
    var wrapped = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = of.apply(this, arguments);
      if (/\/cart\/(add|change|update)(\.js)?/.test(url) && !(init && init.__blrSync)) {
        p.then(function () { setTimeout(syncNow, 300); }, function () {});
      }
      return p;
    };
    wrapped.__blrWrapped = true;
    window.fetch = wrapped;
  })();
  scrubSeal(); watchRoot(); syncNow();
})();
